module.exports = __webpack_public_path__ + "img/text_highscore.2a871680.png";